const constants = {
  CONTROLLER_HEIGHT: '48px',
  DROPDOWN_OFFSET: '80px',
};

export default constants;
